

// TESTING
export const environment = {
  production: false,
  favoriotPaymentUrl: 'https://payment.favoriot.com/favoriot/',
  favoriotPaymentUrl2: 'https://payment.favoriot.com/',
  apiUrl: 'https://apiv2.favoriot.com/v2/',
  apiUrlWOVersion: 'https://apiv2.favoriot.com/',
  summaryDataUrl: 'https://apiv2.favoriot.com/favoriotadmin/',
  licenseUrl: 'https://license.favoriot.com',
  analyticUrl: 'https://analytic.favoriot.com'    
};

// export const environment = {
//   production: false,
//   favoriotPaymentUrl: 'https://payment.favoriot.com/favoriot/',
//   favoriotPaymentUrl2: 'https://payment.favoriot.com/',
//   apiUrl: 'http://178.128.54.104:12000/v2/',
//   apiUrlWOVersion: 'http://178.128.54.104:12000/',
//   summaryDataUrl: 'http://178.128.54.104:12000/favoriotadmin/',
//   licenseUrl: 'https://license.favoriot.com',
//   analyticUrl: 'https://analytic.favoriot.com'
// };


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
